//import {swalBootstrap} from './swallBootstrap';
import {i18n} from "translate/i18n";

import Swal from "sweetalert2";

const swalBootstrap = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-success mx-1',
        cancelButton: 'btn btn-secondary mx-1'
    },
    buttonsStyling: false
})


export function swalError(message) {
    return swalBootstrap.fire({
        title: 'Oops!',
        html: message,
        icon: 'error'
    });
}

export function swalBadRequest() {
    return swalBootstrap.fire({
        title: 'Oops!',
        html: i18n.t('error.badRequest'),
        icon: 'error'
    });
}

export function swalSuccess(message) {
    return swalBootstrap.fire({
        title: '',
        html: message,
        icon: 'success'
    });
}

export function swalWarning(message) {
    return swalBootstrap.fire({
        title: 'Oops!',
        html: message,
        icon: 'warning'
    });
}

export function swalQuestion(message, title = '') {
    return swalBootstrap.fire({
        title: title,
        html: message,
        icon: 'question',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        reverseButtons: true
    })
}

export function swalLoading() {
    return swalBootstrap.fire({
        title: 'Aguarde...',
        html: 'Processando informações',
        timerProgressBar: true,
        didOpen: () => {
            Swal.showLoading()
        },
    })
}

export function swalClose() {
    return Swal.close()
}

